import dayjs, { Dayjs } from "dayjs";

export const formatDate = (date?: Dayjs | Date | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("DD/MM/YYYY");
};

export const formatDateTime = (date?: Date | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("DD/MM/YYYY HH:mm");
};

export const formatTime = (date?: Date | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("HH : mm");
};

export const formatDateTimeNoAMPM = (date?: Date | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("DD/MM/YYYY HH:mm");
};

export const formatDateTimeWithSeconds = (date?: Date | null) => {
  if (!date) {
    return "";
  }
  return dayjs(date).format("DD/MM/YYYY HH:mm:ss");
};

export const formatDateExport = (date?: Date | null) => {
  return dayjs(date).format("DD-MM-YYYY");
};
